export default "__VITE_ASSET__BNKgqAL4__"